import BaseComponent from "../../../baseComponent.js";
import styles from "./styles.scss";

export default class Function extends BaseComponent {
  constructor(props) {
    super(props);
  }

  componentDidUpdate() {
    var _this = this;
    this.refs.function.addEventListener('dragstart', function (e) {
      var data = {
        name: _this.props.function.name + "()"
      };
      e.dataTransfer.setData("data", JSON.stringify(data));
      e.dataTransfer.setData("text/plain", _this.props.function.name + "()");
      this.publish(Event.Dashboard.AddWidget.FIELD_DRAG_START);
    }, false);

    this.refs.function.addEventListener('dragend', function (e) {
      this.publish(Event.Dashboard.AddWidget.FIELD_DRAG_END);
    }, false);
  }

  render() {
    return (
      <li className={styles.function} draggable="true" ref="function">
        <div>{this.props.function.name}</div>
        <div>{this.props.function.type}</div>
      </li>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/add-widget/search/function.jsx